import { Drawer } from "antd";
import { useState, useEffect } from "react";

export default function CreateDrawer({
  open,
  onClose,
  title,
  width,
  children,
}) {
  const [drawerWidth, setDrawerWidth] = useState(600);
  useEffect(() => {
    const updateWidth = () => {
      if (window.innerWidth < 768) {
        setDrawerWidth("100%"); 
      } else if (window.innerWidth == 768) {
          setDrawerWidth(400); 
      } else if (window.innerWidth < 1024) {
        setDrawerWidth(450); 
      } else {
        setDrawerWidth(600);
      }
    };
    updateWidth(); // Set width initially
    window.addEventListener("resize", updateWidth); // Update on resize

    return () => window.removeEventListener("resize", updateWidth);
  }, [width]);
  return (
    <>
      <Drawer
        width={drawerWidth}
        title={`${title}`}
        placement='right'
        onClose={onClose}
        open={open}
      >
        {children}
      </Drawer>
    </>
  );
}
